import { Component, input, output } from '@angular/core';

import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { urlValidator } from '../../configuration-utils';

export interface CallbackUrlDialogData {
  url: string;
}

@EnableClassTelemetry()
@Component({
  selector: 'app-callback-url-dialog',
  templateUrl: './callback-url-dialog.component.html',
  styleUrls: ['./callback-url-dialog.component.scss'],
  standalone: false,
})
export class CallbackUrlDialogComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  urlForm: UntypedFormGroup;
  readonly url = input<string>();
  readonly modalClosed = output<string>();

  constructor(private formBuilder: UntypedFormBuilder) {
    this.urlForm = this.formBuilder.group({
      url: [this.url(), Validators.compose([Validators.required, urlValidator])],
    });
  }

  cancel() {
    this.modalClosed.emit(null);
  }

  save() {
    this.modalClosed.emit(this.urlForm.controls.url.value);
  }
}
